// The starting picture (/welcome Act 3) and the one-tap start window, shared
// by /welcome and the app-wide first-read bar (#2359). Pure: no React, no
// API, so the app shell can import it without pulling in the welcome page.

// One tap starts the dive (#2163, founder pick A 2026-09-28): the confirm
// modal is gone, but the read adds the college (which spends from the
// student's balance), so nothing is requested for this long after the tap.
// Cancel inside the window is the honest escape hatch; a Cancel shown AFTER
// the request fired would be a lie, the college is already added.
export const DIVE_GRACE_MS = 3000; // the bar's 3s in tailwind.config.js ('dive-grace') must match

// One likely + one target + one reach, preferring the student's own state so
// the picture feels personal, not generic.
/** The real fit-candidates item shape, made uniform. The API returns
 * {name, fit_category, state, match, acceptance_rate} — older callers and
 * fixtures used {university_name, soft_fit_category, location}. Both founder
 * device runs failed HERE: the page filtered on a field the API never sends,
 * so every real candidate was silently dropped. */
export function normalizeCandidate(c) {
    if (!c) return null;
    const name = c.university_name || c.name;
    if (!name) return null;
    return {
        ...c,
        university_name: name,
        soft_fit_category: c.soft_fit_category || c.fit_category || null,
        location: c.location || c.state || '',
    };
}

/** The starting picture is ASPIRATIONAL (founder call 2026-07-29): a 3.93
 * student was greeted by one no-name safety, because the old compose pulled
 * the top-60 by raw match ordering — which for a strong record is sixty safeties, with
 * every reach sorted past the limit. First-timers get hooked by top schools;
 * realism lives in the app once they're in. So: two reaches (the backend's
 * reach composition already leads with in-state publics + national dream
 * schools) and one target — never a safety on this screen.
 */
export function composeStartingPicture(reaches, targets) {
    const isReach = (c) => ['REACH', 'SUPER_REACH'].includes(c.soft_fit_category);
    const r = (reaches || []).map(normalizeCandidate).filter(Boolean).filter(isReach);
    const t = (targets || []).map(normalizeCandidate).filter(Boolean)
        .filter((c) => c.soft_fit_category === 'TARGET');
    const picks = [];
    const seen = new Set();
    const take = (c) => {
        if (c && !seen.has(c.university_id) && picks.length < 3) {
            seen.add(c.university_id);
            picks.push(c);
        }
    };
    // The founder's slate (2026-07-29): the home-state reach first (the dream
    // with the residency edge), then an out-of-state reach (the national
    // dream), then a target. Fills keep the screen at three when a slot is
    // genuinely empty.
    take(r.find((c) => c.in_state));
    take(r.find((c) => !c.in_state && !seen.has(c.university_id)));
    take(t[0]);
    [...r, ...t.slice(1)].forEach(take);
    return picks;
}
